<template>
  <div v-if="!isLoading">
    <portal target-el="#filter">
      <div class="sub-header">
        <div class="header-item">
          <Breadcrumb type="flex" separator-class="el-icon-arrow-right">
            <breadcrumb-item>
              <span @click="routeToWorkflowList">
                <svgicon name="left_arrow" class="icon" width="12" height="12"
                  style="padding-right: 5px; padding-bottom: 2px;" :original="true" />
                Workflow
              </span>
            </breadcrumb-item>
          </Breadcrumb>
        </div>
      </div>
    </portal>
      <div class="d-flex" style="justify-content: end;">
      </div>
      <div class="d-flex">
        <div v-if="isEditEnabled">
          <h4 class="mb-15 ml-15 text-lowercase text-md">
            Steps
          </h4>
          <div class="steps" style="width: 150px;">
            <div
              v-for="(step, index) in steps"
              :key="index"
              class="step-active"
              :class="['step', { completed: index < currentStep }]"
            >
              <div class="step-number">{{ index + 1 }}</div>
              <span>{{ step }}</span>
            </div>
          </div>
        </div>
        <WorkflowPreview
          v-if="!isEditEnabled"
          :workflow="workflow"
          @edit-workflow="editWorkflow"
        />
        <ShipmentDetails
          v-if="isEditEnabled && currentStep === 0"
          :workflow="workflow"
          @next-step="moveToNextStep"
        />
        <EventSelection
          v-if="isEditEnabled && currentStep === 1"
          :workflow="workflow"
          @previous-step="previousStep"
          @next-step="moveToNextStep"
        />
        <AttachPrePostEvents
          v-if="isEditEnabled && currentStep === 2"
          :workflow="workflow"
          :prePostEvents="prePostEvents"
          @previous-step="previousStep"
          @next-step="moveToNextStep"
        />
        <WorkflowEditPreview
          v-if="isEditEnabled && currentStep === 3"
          :workflow="workflow"
          @previous-step="previousStep"
          @next-step="moveToNextStep"
        />
      </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import { menuList } from '@/constants/shipment-workflow';
import workflowEventsListConstants from '@common/constants/workflowConstants';
import EventSelection from './eventSelection.vue';
import ShipmentDetails from './shipmentDetails.vue';
import WorkflowEditPreview from './workflowEditPreview.vue';
import WorkflowPreview from './workflowPreview.vue';
import HeadPanel from '@common/components/HeadPanel';
import AttachPrePostEvents from './attachPrePostEvents.vue'

export default {
  components: {
    HeadPanel,
    PrimaryFilter,
    EventSelection,
    ShipmentDetails,
    WorkflowEditPreview,
    AttachPrePostEvents,
    WorkflowPreview,
  },

  data() {
    return {
      menuList,
      indentList: [],
      metricsCountLoading: false,
      steps: ['Basic Info', 'Details', 'Pre Post Events', 'Overview'],
      currentStep: 0,
      workflow: {},
      workflowId: '',
      isLoading: true,
      prePostEvents: [],
      isEditEnabled: false,
      workflowEventsList: cloneDeep(workflowEventsListConstants),
    };
  },
  computed: {
    selectedCategory() {
      const path = this.$router.history.current.name;
      return this.menuList.find(menu => menu.id === path);
    },
  },
  async created() {
    // this.workflow = {};
    // this.workflowId = '';
    this.isLoading = true;
    await this.getWorkflowDetail();
    await this.getPrePostEvents();
    this.isLoading = false;
  },
  methods: {
    moveToNextStep() {
      this.currentStep = this.currentStep + 1;
    },
    editWorkflow() {
      this.isEditEnabled = true;
    },
    previousStep() {
      this.currentStep = this.currentStep - 1;
    },
    async getWorkflowDetail() {
      this.workflowId = this.$route.params.id;
      let result;
      if (this.workflowId && (this.workflowId !== 'create')) {
        const detail = await this.$store.dispatch(
          'app/getWorkflowsDetail', this.workflowId,
        );
        console.log('detail=============== ', detail);
        if (detail.data) {
          result = {
            ...detail.data,
            events: this.constructEvents(detail.data.events),
          };
        }
      } else {
        this.isEditEnabled = true;
        result = this.getDefaultWorkflow();
      }
      if (result) {
        this.workflow = result;
      }
    },
    async getPrePostEvents() {
      const events = await this.$store.dispatch('app/getPrePostEvents');
      if (events && events.data && events.data.length) {
        this.prePostEvents = events.data;
      }
    },
    getDefaultWorkflow() {
      const defaultSelectedEvents = ['INDENT_CREATION', 'MARK_DELIVER'];
      return {
        movement_type: '',
        delivery_type: '',
        events: this.workflowEventsList.map((event) => {
          if (defaultSelectedEvents.includes(event.key)) {
            event.isSelected = true;
          } else {
            event.isSelected = false;
          }
          return event;
        }),
      };
    },
    constructEvents(existingEvents = []) {
      const selectedEvents = existingEvents.reduce((acc, item) => {
        acc[item.key] = item;
        return acc;
      }, {});
      return this.workflowEventsList.map((event) => {
        if (selectedEvents[event.key]) {
          event.isSelected = true;
          event.pre_events = selectedEvents[event.key].pre_events || [];
          event.post_events = selectedEvents[event.key].post_events || [];
        }
        return event;
      });
    },
    async routeToWorkflowList() {
      this.$router.push({ name: 'ShipmentWorkflow' });
    },
  },
};
</script>

<style scoped>

.steps {
  display: flex;
  flex-direction: column;
}

.step {
  padding: 10px;
  margin-bottom: 10px;
  position: relative;
  transition: all 0.3s;
}

.step-number {
  width: 24px;
  height: 24px;
  background: #ccc;
  color: #fff;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  line-height: 24px;
  margin-right: 8px;
}

.step-title {
  display: inline-block;
}

.step-active .step-number {
  background: linear-gradient(0deg, rgba(0, 118, 221, 0.1), rgba(0, 118, 221, 0.1)) !important;
  color: black;
  border-color: black;
}

.step.completed .step-number {
  background: rgb(31, 205, 147) !important;
  color: white;
}

.form-content {
  flex: 1;
  padding-left: 20px;
}

.navigation-buttons {
  margin-top: 20px;
}
</style>

